import React, { useState } from "react";
import "../LandingPage.css";
import "./AccountDataDeletion.css";

function AccountDataDeletion() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch("/api/deleteUserData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setIsSubmitted(true);
      } else {
        const data = await response.json();
        setError(data.message || "An error occurred. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="landing-container">
      {/* HEADER */}
      <header className="site-header">
        <nav className="main-nav">
          <a className="logo-link" href="/">
            <h1 className="logo-text">
              NewTherapy.ai <sup>(Beta)</sup>
            </h1>
          </a>
          <ul className="nav-links">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/chat" className="button primary-button">
                Chat Now
              </a>
            </li>
          </ul>
        </nav>
      </header>

      {/* MAIN CONTENT */}
      <section className="hero-section">
        <div className="hero-content">
          <h2 className="hero-title">Android App Data Deletion</h2>
          <p className="hero-subtext">
            Request permanent deletion of all your data from the Android app "AI Therapist"
          </p>

          <div className="warning-box">
            <h3>⚠️ Warning: Permanent Data Deletion</h3>
            <p>
              Submitting this form will <strong>permanently delete all your user data</strong> from the "AI Therapist" Android app. This includes:
            </p>
            <ul>
              <li>All conversation history</li>
              <li>User preferences and settings</li>
              <li>Account information</li>
            </ul>
            <p className="warning-text">
              This action is <strong>irreversible</strong> and cannot be undone. Once deleted, your data cannot be recovered.
            </p>
          </div>

          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="deletion-form">
              <div className="form-group">
                <label htmlFor="email-input">Enter the email address associated with your account:</label>
                <input
                  id="email-input"
                  type="email"
                  value={email}
                  onChange={handleInputChange}
                  placeholder="Enter your email address"
                  required
                  className="email-input"
                />
                {error && <p className="error-message">{error}</p>}
              </div>
              <div className="confirm-deletion">
                <p>By clicking the button below, you confirm that you understand all your data will be permanently deleted.</p>
              </div>
              <button
                type="submit"
                className="button primary-button delete-button"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Permanently Delete My Data"}
              </button>
              <p className="form-helper-text">
                Press Enter or click the button to submit your deletion request.
              </p>
            </form>
          ) : (
            <div className="success-message">
              <h3>Deletion Request Received</h3>
              <p>
                Your data deletion request for <strong>{email}</strong> has been successfully submitted.
              </p>
              <p>
                All data associated with this email in the "AI Therapist" Android app will be permanently deleted from our systems. This process is irreversible.
              </p>
              <a href="/" className="button secondary-button">
                Return to Home
              </a>
            </div>
          )}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="footer-main">
          <div className="footer-col">
            <h5>Main</h5>
            <ul>
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms-of-service">Terms of Service</a>
              </li>
              <li>
                <a href="mailto:support@newtherapy.ai">Support</a>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h5>Product</h5>
            <ul>
              <li>
                <a href="/chat">Chat Now</a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AccountDataDeletion; 